export default __webpack_public_path__ + "static/media/tokenDemand2.28187394.png";